import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useStyle } from "../context/StyleContext";
import Navbar from "./Navbar";

const ThankYouScreen = () => {
  const navigate = useNavigate();
  const styles = useStyle();

  const clearAndRestoreLocalStorage = useCallback(() => {
    const boothNameKey = "photobooth_boothName";
    const boothNameValue = localStorage.getItem(boothNameKey);

    localStorage.clear();

    if (boothNameValue !== null) {
      localStorage.setItem(boothNameKey, boothNameValue);
      localStorage.setItem("hasVisitedWelcomeScreen", "false");
    }
  }, []);

  useEffect(() => {
    clearAndRestoreLocalStorage();

    const timeout = setTimeout(() => {
      navigate("/");
    }, 25000);

    return () => clearTimeout(timeout);
  }, [clearAndRestoreLocalStorage, navigate]);

  const handleGoHome = () => {
    clearAndRestoreLocalStorage();
    navigate("/");
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src={styles.restaurantLogo}
        width={"600px"}
        alt="Background"
        className="absolute top-[5%] left-1/2 transform -translate-x-1/2 w-l h-l object-cover m-5 z-0"
      />
      <div className="relative mt-64 z-10 pt-24 text-center">
        <motion.h1
          className="text-6xl font-bold text-white mt-12 pt-16 mb-8"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
        >
          Thank You!
        </motion.h1>
        <div className="mt-12 pt-12">
          <motion.p
            className="text-3xl mb-7"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          >
            Your photos have been printed and shared successfully.
          </motion.p>
          <motion.p
            className="text-3xl mb-12 pb-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
            style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          >
            You will be redirected to the home page shortly.
          </motion.p>
          <motion.div
            className="text-2xl max-w-5xl mb-12 pb-12 m-auto mt-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          >
            Refund Policy: Full refunds will be given for any mistakes on our
            end within 5-7 working days. Deposits are non-refundable otherwise.
            Contact us at memeoriesphotosbooth@gmail.com or +91 96861 45731 (
            memoris photosbooth )
          </motion.div>
          <motion.div
            className="text-2xl max-w-5xl mb-12 pb-12 m-auto mt-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          >
            we do not provide any shipping
          </motion.div>
          <motion.div
            className="text-2xl max-w-3xl mb-12 pb-12 m-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          >
            72/1 B,B Osmaan Khan Road,3rd Cross, NR Rd, near Naaz Complex,
            Kalasipalyam New Extension, Bengaluru, Karnataka 560002
          </motion.div>
        </div>
        <motion.button
          onClick={handleGoHome}
          className="px-6 py-3 my-5 font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition duration-300 ease-in-out relative inline-flex items-center justify-center overflow-hidden tracking-tighter group"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          style={{
            backgroundColor: styles.backgroundColor,
            fontFamily: styles.fontFamily,
          }}
        >
          <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-green-500 rounded-full group-hover:w-56 group-hover:h-56"></span>
          <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-700"></span>
          <span
            className="relative text-5xl p-5"
            style={{
              fontFamily: styles.fontFamily,
              fontWeight: "bold",
              color: styles.textColor,
            }}
          >
            Go To Home
          </span>
        </motion.button>
      </div>
    </div>
  );
};

export default ThankYouScreen;
